import { Box, Button, Stack, Typography } from '@mui/material';
import { ReactElement, useCallback, useState } from 'react';

import { TaxonomySingleSelector } from 'app/components/form-controls/taxonomy-single-selector';
import { Brand } from 'app/model/cris/brand';
import { Taxonomy } from 'app/model/taxonomy';
import { brandService } from 'app/services/brand.service';
import { dialogService } from 'app/services/dialog.service';
import { messagingService } from 'app/services/messaging.service';

interface BrandDetailsMoveTaxonomyTabProps {
    brand: Brand;
}
export const BrandDetailsMoveTaxonomyTab: (props: BrandDetailsMoveTaxonomyTabProps) => ReactElement = ({ brand }) => {
    // eslint-disable-next-line no-null/no-null
    const [selectedTaxonomy, setSelectedTaxonomy] = useState<Taxonomy | null>(null);
    const moveTaxonomy = useCallback(() => {
        dialogService.showConfirm(
            {
                message: 'Are you sure you want to move this brand and all related records to new taxonomy?',
            },
            () =>
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                brandService.moveTaxonomy(brand, selectedTaxonomy!).subscribe(() => {
                    messagingService.showSuccess('Saved');
                }),
        );
    }, [brand, selectedTaxonomy]);

    return (
        <>
            <Stack>
                <Typography variant='body1' mb={2}>
                    Move this brand and all related records to new taxonomy
                </Typography>
                <Stack direction='row' alignItems='center'>
                    <TaxonomySingleSelector
                        disableClearable
                        color='inherit'
                        variant='outlined'
                        size='small'
                        className='m-1'
                        sx={{ width: 200 }}
                        onChange={(evt, value) => {
                            setSelectedTaxonomy(value);
                        }}
                        renderOption={(renderProps, option) => (
                            <Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...renderProps}>
                                {/* <img*/}
                                {/*    loading="lazy"*/}
                                {/*    width="20"*/}
                                {/*    src={'https://flagcdn.com/w20/us.png'}*/}
                                {/*    srcSet={'https://flagcdn.com/w40/us.png 2x'}*/}
                                {/*    alt=""*/}
                                {/* />*/}

                                {`${option.name}${option.id === brand.taxonomy?.id ? ' (current)' : ''}`}
                            </Box>
                        )}
                        getOptionDisabled={(option) => option.id === brand.taxonomy?.id}
                        value={selectedTaxonomy}
                    />
                    <Button disabled={!selectedTaxonomy} variant='outlined' onClick={() => moveTaxonomy()}>
                        Save
                    </Button>
                </Stack>
            </Stack>
        </>
    );
};
